import { render, staticRenderFns } from "./ProjectView.vue?vue&type=template&id=ad96443c&scoped=true&"
import script from "./ProjectView.vue?vue&type=script&lang=js&"
export * from "./ProjectView.vue?vue&type=script&lang=js&"
import style0 from "./ProjectView.vue?vue&type=style&index=0&id=ad96443c&prod&scoped=true&lang=css&"
import style1 from "./ProjectView.vue?vue&type=style&index=1&id=ad96443c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad96443c",
  null
  
)

export default component.exports